import { render } from "./HoiDongQuanTri.vue?vue&type=template&id=5647c50f"
import script from "./HoiDongQuanTri.vue?vue&type=script&lang=js"
export * from "./HoiDongQuanTri.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__